//TODO: Complete
'use client';
import { iStorageSizeAdvanced } from '@/app/models/storageSizeAdvanced';
import StorageSizeCardAdvanced from '../StorageSizeCardAdvanced/StorageSizeCardAdvanced';
import { useEffect, useRef, useState } from 'react';
import styles from './storagesizesadvanced.module.scss';

interface Props {
    translations: any;
    temporaryOrgName?: string;
    units: iStorageSizeAdvanced[];
    handleCardClick: (storage: iStorageSizeAdvanced) => void;
    visibleCardCount?: number;
    country: string;
    isExpanded?: boolean;
    isOnAreaPage?: boolean;
}

export default function StorageUnitsSlider({ units, translations, temporaryOrgName, handleCardClick, visibleCardCount = 2, country, isExpanded, isOnAreaPage = false }: Props) {
    const [visibleUnits, setVisibleUnits] = useState<iStorageSizeAdvanced[]>(units);

    const unitCardsRef = useRef<HTMLDivElement>(null);
    const [scrollPosition, setScrollPosition] = useState(0); // Tracks the current scroll position
    const [maxScroll, setMaxScroll] = useState(0); // Tracks the maximum scrollable width
    const [showLeftArrow, setShowLeftArrow] = useState(false); // Controls left arrow visibility
    const [showRightArrow, setShowRightArrow] = useState(false); // Controls right arrow visibility
    const [showScrollIndicator, setShowScrollIndicator] = useState(false); // Controls scroll indicator visibility
    const [cardWidth, setCardWidth] = useState<number>(0); // State to store the calculated card width
    const [calculatedCardWidth, setCalculatedCardWidth] = useState<number>(0); // State to store the calculated card width

    useEffect(() => {
        if (isExpanded) {
            calculateMaxScroll();
        }
    }, [isExpanded]);

    useEffect(() => {
        setVisibleUnits(units);
    }, [units]);

    useEffect(() => {
        if (unitCardsRef.current) {
            const container = unitCardsRef.current;

            const calculatedCardWidth = container.offsetWidth / visibleCardCount ; // Calculate card width
            setCardWidth(calculatedCardWidth); // Save it to state
            setCalculatedCardWidth(calculatedCardWidth - (24 / visibleCardCount)); // Adjust for gap

            if (visibleCardCount >= units.length) {
                setShowRightArrow(false); // Hide right arrow if all cards are visible
                setShowScrollIndicator(false); // Hide scroll indicator if all cards are visible
            } else {
                setShowScrollIndicator(true); // Show scroll indicator if not all cards are visible
            }
        }
    }, [visibleCardCount, units]);

    useEffect(() => {
        calculateMaxScroll();
    }, [visibleUnits]); // Recalculate when the number of units changes

    const calculateMaxScroll = () => {
        if (unitCardsRef.current) {
            const container = unitCardsRef.current;
            const calculatedMaxScroll = container.scrollWidth - container.clientWidth; // Calculate max scroll directly
            setMaxScroll(calculatedMaxScroll); // Save it to state for future use
            updateArrowVisibility(container.scrollLeft, calculatedMaxScroll); // Pass the calculated max scroll
        }
    }

    const scrollUnits = (direction: "left" | "right", scrollByVisibleCards: boolean = false) => {
        if (!unitCardsRef.current) return;

        const container = unitCardsRef.current;
        const gapInPixels = 24; //Which is 1.5rem

        const scrollAmount = scrollByVisibleCards
            ? (cardWidth * visibleCardCount) + (gapInPixels * (visibleCardCount - 1)) // Add the gap for multiple cards
            : cardWidth + gapInPixels; // Add the gap for a single card

        if (direction === "left") {
            container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
        } else if (direction === "right") {
            container.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }

        // Update scroll position and arrow visibility after scrolling
        setTimeout(() => {
            setScrollPosition(container.scrollLeft);
            updateArrowVisibility(container.scrollLeft);
        }, 300); // Delay to allow smooth scrolling to complete
    };

    const updateArrowVisibility = (scrollLeft: number, calculatedMaxScroll?: number) => {
        const maxScrollValue = calculatedMaxScroll !== undefined ? calculatedMaxScroll : maxScroll; // Use the passed value or fallback to state
        setShowLeftArrow(scrollLeft > 0); // Show left arrow if not at the start
        setShowRightArrow(scrollLeft < maxScrollValue); // Show right arrow if not at the end
    };

    return (

        <div className="relative mt-4">
            {/* Left Arrow */}
            {showLeftArrow && (
                <button
                    className={`absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-gray-200 hover:bg-gray-300 rounded-full p-2 ${styles.sliderButtonLeft} bg-gs-green-hover`}
                    onClick={() => scrollUnits("left", true)} // Pass `true` to scroll by visible cards
                >
                    {/* &#8249; Left caret */}
                </button>
            )}

            {/* Scrollable Container */}
            <div
                //id="unitCards" // this produces multiple matching IDs
                className="flex overflow-hidden scroll-smooth"
                ref={unitCardsRef}
            >
                <div className={`flex flex-row gap-6`}>
                    {visibleUnits.map((storage, index) => (
                        <div
                            key={index}
                            className="flex-shrink-0" // Adjust width as needed
                            style={{ width: `${calculatedCardWidth}px` }}
                        >
                            <StorageSizeCardAdvanced
                                storage={storage}
                                translations={translations}
                                temporaryOrgName={temporaryOrgName}
                                onClick={handleCardClick}
                                isSmallCard={true}
                                className="w-full h-full"
                                country={country}
                                isOnAreaPage={isOnAreaPage}
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Scroll Indicator */}
            {showScrollIndicator && (
                <div className="relative mt-2 h-1 bg-gs-black-50">
                    <div
                        className="absolute top-0 left-0 h-full bg-gs-green transition-all"
                        style={{
                            width: `calc(${Math.max((scrollPosition / maxScroll) * 100, 1)}%)`, // Calculate the width of the green bar
                        }}
                    ></div>
                </div>
            )}

            {/* Right Arrow */}
            {showRightArrow && (
                <button
                    className={`absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-gray-200 hover:bg-gray-300 rounded-full p-2 ${styles.sliderButtonRight} bg-gs-green-hover`}
                    onClick={() => scrollUnits("right", true)} // Pass `true` to scroll by visible cards
                >

                </button>
            )}
        </div>
    )
}


